module.exports = __webpack_public_path__ + "static/media/running.5e23a96d.jpg";